<template>
  <div>
    <div class="container-alb filter-mobile">
      <table
        cellpadding="10"
        cellspacing="0"
        width="95%"
        class="hover-table"
        align="center"
      >
        <tr>
          <td>
            {{ $t("finance.companyTypeLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <select class="filtrare" v-model="filters.type">
                <option value="" :selected= " ''=== filters.type">                {{ $t('cardsAction_CHOOSE') }}              </option>
                <option v-for="(entry, index) in companyTypes" :key="index" :value="entry"
                  :selected="entry  === filters.type">
                  {{ $t('finance.companyType_' + entry) }}
                </option>
              </select>
            </form>
          </td>
          <td>
            {{ $t("finance.companyCodeLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="number"
                @wheel.prevent
                class="formedituser"
                v-model="filters.companyCode"
                v-on:keyup.enter="searchInvoices()"
              />
            </form>
          </td>
          <td>
            {{ $t("finance.companyNameLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="text"
                class="formedituser"
                v-model="filters.name"
                v-on:keyup.enter="searchInvoices()"
              />
            </form>
          </td>
          
        </tr>
        <tr>
          <td>
            {{ $t("finance.invoiceNumberLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="number"
                @wheel.prevent
                class="formedituser"
                v-model="filters.invoiceNumber"
                v-on:keyup.enter="searchInvoices()"
              />
            </form>
          </td>
          <td>
            {{ $t("finance.productLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <select class="filtrare" v-model="filters.product">
                <option v-for="(entry, index) in products" :key="index" :value="entry"
                  :selected="entry  === filters.product">
                  {{ $t('finance.product_' + entry) }}
                </option>
              </select>
            </form>
          </td>
          <td>
          {{ $t("finance.mandateStatusLabel") }}

            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <select class="filtrare" v-model="filters.status">
                <option v-for="(entry, index) in statuses" :key="index" :value="entry"
                  :selected="entry  === filters.status">
                  {{ $t('finance.invoiceStatus_' + entry) }}
                </option>
              </select>
            </form>
          </td>
          
        </tr>
        <tr>
          <td>
            <a
                  class="notification-action custom-notification-action"
                  @click="searchInvoices()"
                  >{{ $t("searchButtonLabel") }}</a
                >
          </td>
        </tr>
      </table>
    </div>

    <!-- card transaction -->
    <div class="container-alb">
            <InvoicesTable
        :invoices="this.invoicesList"
      />
      <!-- <tr v-if="this.companyOrders === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr> -->
      <br />


      <div
        class="error-wrapper border-box"
        v-if="this.invoicesList && this.invoicesList.length === 0"
      >
        <p>{{ $t("finance.noCustomerInvoiceLabel") }}</p>
      </div>

      <div class="pagination-wrapper border-box">
        <b-pagination
          v-model="currentPage"
          :total-rows="this.invoicesCount"
          :per-page="perPage"
          size="sm"
        ></b-pagination>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <p v-html="$t('errorActionBeneficiary_' + this.error.code)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import httpServiceFinance from "@/http/http-finance.js";
  import { BPagination } from "bootstrap-vue";
  import Cookies from "js-cookie";
  import InvoicesTable from "./ClientInvoicesTable.vue";

  export default {
    props: {
      msg: String,
    },
    components: {
      "b-pagination": BPagination,
      InvoicesTable
      // Multiselect
    },
    data() {
      return {
        transactionError: null,
        invoicesList: [],
        tempInvoices: null,
        companyTypes: ["AF", "CL"],
        products: [0, 11, 12, 13, 14, 15],
        statuses: ["", "P", "N", "V", "E"],
          // filtrare dupa (tip entitate (client / afiliat), identificator (cod client / cod afiliat), name, produs, nr factura, status)
        filters: {
          type: "",
          companyCode: "",
          name: "",
          invoiceNumber: "",
          product: 0,
          status: "",
        },
        invoicesCount: 10,
        perPage: 10,
        currentPage: 1,
        sortField: "",
        sortDirection: "asc",
        selectedProduct: null,
        error: null,
      };
    },
    methods: {
      productSelected(event) {
        this.filters.product = event.target.value;
        this.searchInvoices();
      },
      isSelectedProduct(product) {
        return product === this.filters.product;
      },
      sortBy(sortField, sortDirection, status) {
        this.sortField = sortField;
        this.sortDirection = sortDirection;
        this.searchInvoices(status);
      },
      searchInvoices() {
        this.error = null;
        this.invoicesList = null;

        var invoicesData = "?"
        invoicesData +=
          "&per_page=" +
          this.perPage +
          "&page=" +
          this.currentPage;

        if (this.filters.type.trim().length > 0) {
          invoicesData += "&type=" + this.filters.type;
        }
        if (this.filters.companyCode.trim().length > 0) {
          invoicesData += "&identifier=" + this.filters.companyCode;
        }
        if (this.filters.name.trim().length > 0) {
          invoicesData += "&name=" + this.filters.name;
        }
        if (this.filters.product > 0) {
          invoicesData += "&product=" + this.filters.product;
        }
        if (this.filters.invoiceNumber.trim().length > 0) {
          invoicesData += "&invoice=" + this.filters.invoiceNumber;
        }
        if (this.filters.status.trim().length > 0) {
          invoicesData += "&status=" + this.filters.status;
        }

        httpServiceFinance.financeService
          .searchClientPayments(invoicesData, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.invoicesList = response.data;
              // this.invoicesList = [{
              //   "id": 33,  
              //   "invoice": 6811380367,  
              //   "status": "P",  
              //   "created": 1780775433166,  
              //   "customer": {  
              //     "type": "CL",  
              //     "identifier": 1,  
              //     "name": "UP ROMANIA SRL",  
              //     "product": 11  
              //     }  
              // }]
              this.invoicesCount = response.headers["x-up-count"];
            } else if (response.status == 400) {
              this.error = { code: response.data.error_code };
            } else {
              this.error = { code: response.error_code };
            }
            if (this.error) {

              this.showModalPopup("modal_popup_info", true);
            }
            this.showModalPopup("modal_popup_loading", false);
          })

      },
      selectProduct(index) {
        this.selectedProduct = this.cardProducts[index];
      },
    },
    mounted() {
      this.searchInvoices();
    },
    watch: {
      currentPage: function () {
        this.searchInvoices();
      },
    },
  };
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
  .page-link {
    color: #4a4a4a;
  }

  .page-link:hover {
    color: #4e5b59;
  }

  .page-item.active .page-link {
    background-color: #4e5b59 !important;
    border-color: #4e5b59 !important;
  }

  .invoices-filter .reportrange-text {
    height: 27px;
    font-size: 13px;
    padding: 3px 10px;
    border: none !important;
    color: #585858;
    background: #f1f1f1;
  }
</style>
